/**
 * Guards de rota (app.md §6). Fase 0: base mínima; regras completas de status entram na Fase 1/4.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';
import { useSessionStore } from '../stores/sessionStore';

interface GuardProps {
  children: ReactNode;
}

/** Exige cookies userId+email (fonte: extensão). Sem eles → onboarding/instalação. */
export function RequireAuth({ children }: GuardProps): ReactNode {
  if (!isAuthenticated()) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

/** Exige sessão com status ativo (após /app/me). */
export function RequireActive({ children }: GuardProps): ReactNode {
  const session = useSessionStore((s) => s.session);
  if (session && session.status !== 'active') {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

